import { render, staticRenderFns } from "./LocationLabelButton.vue?vue&type=template&id=e825680c&scoped=true"
import script from "./LocationLabelButton.vue?vue&type=script&lang=js"
export * from "./LocationLabelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e825680c",
  null
  
)

export default component.exports